// client/src/components/categorias/FiltroCategorias.js - VERSÃO 100% PADRONIZADA
import React, { useState, useEffect } from 'react';
import { Search, X, Loader2 } from 'lucide-react';

const initialFilterState = {
    search: '',
    tipo: '',
    ativo: ''
};

const FiltroCategorias = ({ onApplyFilters, loading, activeFilters = {} }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);

    // Sincroniza filtros locais se os filtros ativos mudarem externamente
    useEffect(() => {
        const cleanActive = Object.fromEntries(
            Object.entries(activeFilters).filter(([_, v]) => v != null && v !== '')
        );
        setLocalFilters(prev => ({ ...initialFilterState, ...cleanActive }));
    }, [activeFilters]);

    const onChange = e => {
        setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
    };

    const onSubmit = e => {
        e.preventDefault();
        console.log('🔍 [FiltroCategorias] Aplicando filtros:', localFilters);
        
        const filtersToApply = Object.fromEntries(
            Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        );
        
        if (onApplyFilters) {
            onApplyFilters(filtersToApply);
        }
    };

    const handleClearFilters = () => {
        setLocalFilters(initialFilterState);
        if (onApplyFilters) {
            onApplyFilters({});
        }
    };
    
    const hasFilters = Object.values(localFilters).some(v => v !== '');

    return (
        <form onSubmit={onSubmit} className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                
                {/* Campo Busca */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-search" className="text-xs font-semibold text-gray-600 uppercase">Nome/Descrição</label>
                    <input 
                        type="text" 
                        name="search" 
                        id="filter-search" 
                        placeholder="Buscar..." 
                        value={localFilters.search} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>
                
                {/* Campo Tipo */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-tipo" className="text-xs font-semibold text-gray-600 uppercase">Tipo</label>
                    <select 
                        name="tipo" 
                        id="filter-tipo" 
                        value={localFilters.tipo} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos os tipos</option>
                        <option value="servico">Serviço</option>
                        <option value="produto">Produto</option>
                        <option value="recurso">Recurso</option>
                        <option value="curso">Curso</option>
                        <option value="geral">Geral</option>
                    </select>
                </div>
                
                {/* Campo Status */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-ativo" className="text-xs font-semibold text-gray-600 uppercase">Status</label>
                    <select 
                        name="ativo" 
                        id="filter-ativo" 
                        value={localFilters.ativo} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos</option>
                        <option value="true">Ativas</option>
                        <option value="false">Inativas</option>
                    </select>
                </div>

                {/* Botões de Ação — antes reinventava cor do zero em Tailwind
                    (bg-blue-600), usava um emoji ⏳ como spinner e o texto
                    "Filtrar" so aparecia acima de 1280px (hidden xl:inline) */}
                <div className="flex gap-2 h-full">
                    <button
                        type="submit"
                        disabled={loading}
                        className="action-button action-button-primary flex-1 justify-center"
                        title="Aplicar Filtros"
                    >
                        {loading ? <Loader2 size={18} className="icon animate-spin" /> : <Search size={18} className="icon" />}
                        Aplicar Filtros
                    </button>

                    {hasFilters && (
                        <button
                            type="button"
                            onClick={handleClearFilters}
                            disabled={loading}
                            className="action-button action-button-secondary justify-center"
                            title="Limpar Filtros"
                        >
                            <X size={18} className="icon" />
                        </button>
                    )}
                </div>
            </div>
        </form>
    );
};

export default FiltroCategorias;